<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header__title">
      {{broker?.name}}
    </mat-card-title>
    <button *ngIf="edit"
            mat-mini-fab
            class="edit-button"
            color="primary"
            (click)="detailsLink()"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>work</mat-icon>
        <span matListItemTitle>{{broker?.dba || '-'}}</span>
        <span matListItemLine>DBA</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>location_on</mat-icon>
        <span matListItemTitle>{{broker?.address?.line1 || '-'}}</span>
        <span matListItemLine>{{broker?.address?.city}},
          {{broker?.address?.state}}
          {{broker?.address?.zip}}
        </span>
        <span *ngIf="broker?.address?.line2"
              matListItemLine>{{broker?.address?.line2}}
        </span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>receipt</mat-icon>
        <span matListItemTitle>{{broker?.ein || '-'}}</span>
        <span matListItemLine>Tax ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{(broker?.phone | phone) || '-'}}</span>
        <span matListItemLine>Primary phone</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>desktop_windows</mat-icon>
        <span matListItemTitle>{{broker?.webSite || '-'}}</span>
        <span matListItemLine>Website</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>email</mat-icon>
        <span matListItemTitle>{{broker?.contactEmail || '-'}}</span>
        <span matListItemLine>Contact email</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>mail</mat-icon>
        <span matListItemTitle>{{broker?.commissionEmail || '-'}}</span>
        <span matListItemLine>Commission email</span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
